import React from 'react';
import { MapEditorCanvas } from '../MapCanvas/MapEditorCanvas';
import { useMapCanvas } from '../contexts/MapCanvasContext';
import { useMapEditor } from '../contexts/MapEditorContext';
import {MapEditorContextMenu}  from './context-menu/MapEditorContextMenu';

export const EditorCanvas: React.FC = () => {
  const { selectedIds, showOutside } = useMapEditor();
  const { stagePosition, updateStagePosition } = useMapCanvas();

  return (
    <div className="map-editor-container absolute inset-0 z-0">
      <MapEditorContextMenu>
        <MapEditorCanvas
          selectedIds={selectedIds}
          showOutside={showOutside}
          stagePosition={stagePosition}
          onStageChange={updateStagePosition}
        />
      </MapEditorContextMenu>
    </div>
  );
};
